var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('page-header',{attrs:{"page":_vm.page}}),_c('squareOption',{attrs:{"menu":_vm.optionList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }